import ReactGa from 'react-ga';

export const gaTracker = (paramCategory, paramAction, paramLabel) => {
    ReactGa.event({
        category: paramCategory,
        label: paramLabel,
        action: paramAction,
    })
};

export const productName = (paramParam) => {
    let result = paramParam;
    return result;
};